/*
 * @Author: zhouzhuoxin
 * @Email: shzhouzhuoxin@jd.com
 * @Date: 2021-03-22 14:20:33
 * @Last Modified time: 2021-08-27 08:46:38
 * @Description: Description
 */
import TreeSelectAcore, { validateSelectMax } from './tree-select-acore';
import React from 'react';

export default React.forwardRef(function treeSelectDepartment(props, ref) {
  return <TreeSelectAcore level={3} {...props} ref={ref} />;
}) as any;

export { validateSelectMax };
